import React from "react";
import { Box } from "@mui/material";
import Input from "models/input/input";
import { FacetFields } from "models/facet-fields";
import Breadcrumb from "components/sitelet/navigation/breadcrumb";
import SearchBar from "components/sitelet/navigation/search-bar";
import searchImage from "images/florafaunaimage.jpg";

const NTHeader = ({
  showBreadcrumb,
  input,
  searchParams,
  facets,
}: {
  showBreadcrumb: boolean;
  input?: Input | null;
  searchParams: URLSearchParams;
  facets: FacetFields;
}) => {
  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        width: "100%",
        maxWidth: "95vw",
      }}
    >
      <Box
        display="flex"
        flexDirection="column"
        sx={{
          width: "100vw",
          backgroundImage: `url(${searchImage})`,
          backgroundSize: "cover",
          backgroundPosition: "center",
          backgroundRepeat: "no-repeat",
          alignSelf: "center",
        }}
        p={2}
        pb={6}
      >
        <SearchBar facets={facets} />
      </Box>
      {showBreadcrumb && (
        <Box
          mt={1}
          display="flex"
          flexDirection="column"
          sx={{
            outline: "none",
            width: "100%",
            alignSelf: "center",
            pb: 1,
            mx: 4,
          }}
        >
          <Breadcrumb
            domain={input?.domain ? input.domain : searchParams.get("Domains")}
            datatype={
              input?.datatype ? input.datatype : searchParams.get("Datatypes")
            }
            group={
              input?.owner_group
                ? input.owner_group
                : searchParams.get("Groups")
            }
            input={input?.input_id}
          />
        </Box>
      )}
    </Box>
  );
};

export default NTHeader;
